import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from "@angular/forms";
import {
  AgActionIconButtonComponent
} from "@shared/components/grid/ag-cells/common/ag-action-icon-button/ag-action-icon-button.component";
import { ButtonComponent } from "@shared/controls/button/button.component";

@Component({
  selector: 'app-common-modal-form',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    AgActionIconButtonComponent,
    ButtonComponent
  ],
  templateUrl: './common-modal-form.component.html',
  styleUrl: './common-modal-form.component.scss'
})
export class CommonModalFormComponent {
  @Input() header = '';
  @Input() subheader = '';
  @Input() icon = 'ic-form-20';
  @Input() isLoading = false;
  @Input() isInvalid = false;
  @Input() closeText = 'Close';
  @Input() confirmText = 'Confirm';
  @Input() footerClass = '';
  @Input() isCustomFooter = false;
  @Input() hideCloseButton = false;

  @Output() confirm = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();

  onConfirm() {
    this.confirm.emit();
  }

  onClose() {
    this.close.emit();
  }
}
